export default __webpack_public_path__ + "static/media/Miter of the Cloudcleaver.c834533f.jpg";